import BaseComponent from '@/components/base';
import ShopifyAPI from '@/gateway/ShopifyAPI';
import { style } from '@/components/quiz/buy-once-regimen/style';

export default class BuyOnceRegimen extends BaseComponent {
  onConstruct() {}

  render() {
    return `
    ${style}

    <button
        class="cta-1 add-all addRegimenToCart"
        style="width: 100%"
        type="submit"
        name="add"
        disabled
    >
        <span class="add-to-cart-text"> ${this.price} <span class="dash"></span>  ${this.buttonTitle}</span>
    </button>
    `;
  }

  afterMount() {
    const quizComponent = document.querySelector('quiz-component');
    const fragranceComponent = quizComponent?.fragranceComponent;
    const hairGoalsComponent = quizComponent?.hairGoalsComponent;
    const hairTypeComponent = quizComponent?.hairTypeComponent;
    const button = this.shadowRoot.querySelector('button');

    button?.addEventListener('click', () => {
      const hairGoals = quizComponent.hairGoals.join(',');
      const fragrance = quizComponent.fragrance;
      const hairType = quizComponent.hairType;
      const regimenObject = {
        __product_handle: this.productHandle,
        __profile_id: 'mini-quiz-sos',
        __profile_name: 'of beauty',
        __profile_type: 'hair',
        __fragrance: fragrance,
        __fragrance_strength: 'light',
        __hair_type: hairType,
        __hair_structure: 'medium',
        __scalp_moisture: 'normal',
        __silicone_free: 0,
        __hair_goals: hairGoals,
        __damage_level: 2,
        __mechanical_damage_level: 2,
        __chemical_damage_level: 1,
        __heat_damage_level: 1
      };

      ShopifyAPI.addToCart({
        items: [
          {
            id: this.variantId,
            quantity: 1,
            properties: regimenObject
          }
        ]
      })
        .then((r) => {
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch((err) => console.error(err));
    });
    // I did this pretty fast , we can improve this for the next ticket
    fragranceComponent?.addEventListener('quizFragranceChange', (event) => {
      this.enableFragrance = true;

      if (
        this.enableFragrance &&
        this.enableHairGoals &&
        this.enableHairTypes
      ) {
        button.removeAttribute('disabled');
      }
    });

    hairGoalsComponent?.addEventListener('quizHairGoalsChange', (event) => {
      this.enableHairGoals = true;

      if (
        this.enableFragrance &&
        this.enableHairGoals &&
        this.enableHairTypes
      ) {
        button.removeAttribute('disabled');
      }
    });

    hairTypeComponent?.addEventListener('quizHairTypeChange', (event) => {
      this.enableHairTypes = true;

      if (
        this.enableFragrance &&
        this.enableHairGoals &&
        this.enableHairTypes
      ) {
        button.removeAttribute('disabled');
      }
    });
  }

  get buttonTitle() {
    return this.getAttribute('button-title');
  }

  get variantId() {
    return this.getAttribute('variant-id');
  }

  get productHandle() {
    return this.getAttribute('product-handle');
  }

  get price() {
    return this.getAttribute('price');
  }
}
